import {createContext,useContext} from 'solid-js';

const PageContext = createContext();

export function PageProvider(props:{documents:XXX})
{
	return (
		<PageContext.Provider value={props}>
			{props.children}
		</PageContext.Provider>
	);
}

export function useDocuments() 
{
	return useContext(PageContext).documents;
}

export function usePageConfig() 
{
	return useContext(PageContext).config;
}

export function usePageContext() 
{
	return useContext(PageContext);
}

